import _ from 'lodash';

window._ = _;

function InjuryCtrl($rootScope, $scope, $state, $stateParams, toastr, AuthService, AnalysisService, PlayerService, DashboardService, AppContextService, PlanService, $ngConfirm) {
  'ngInject';

  const vm = this;
  vm.appContext = AppContextService.context;

  if (vm.appContext.role2 === 'player') {
    $state.go('Service.injuryDetail', { user_id: vm.appContext.user.user_id });
    return;
  }


  // // vm.date = new Date().toISOString().split("T")[0].split("-").join(".");
  vm.date = '';

  // var getInjuryList = function (date) {

  // }

  // getInjuryList();


  // $scope.$watch('injury.date', function (newVal, oldVal) {
  //   if (newVal !== oldVal) {
  //     getInjuryList(newVal);

  //   }
  // });



  vm.video = {
    title: '',
    url: ''
  };

  vm.content = {
    title: '',
    subtitle: '허리',
    type: 'url',
    url: ''
  };

  var dataList = function (date, from, to, type) {
    var getInjuryData = {};
    getInjuryData.login_id = vm.appContext.user.login_id;
    getInjuryData.uuid = vm.appContext.user.uuid;
    if (from && to) {
      getInjuryData.from = from;
      getInjuryData.to = to;
    } else if (date) {
      getInjuryData.date = date;
    } else if (type) {
      // 위치별
      if (type === 'location') {
        getInjuryData.location_id = vm.metaData.location.id;
      }
      // 부위별
      else if (type === 'part') {
        getInjuryData.ipart_id = vm.metaData.part.id;
      }
      // 상황별
      else if (type === 'movement') {
        getInjuryData.movement_id = vm.metaData.movement.id;
      }
      // 구분별
      else if (type === 'cause') {
        getInjuryData.icause_id = vm.metaData.cause.id;
      }
      // 선수별
      else if (type === 'user') {
        $state.go('Service.injuryDetail', {user_id: vm.metaData.user.user_id});
        return;
      }
    }

    // 전체관리자가 선택한 team_id
    if ($stateParams.manager_admin_team_id) {
      getInjuryData.team_id = $stateParams.manager_admin_team_id;
    }

    AnalysisService.getInjury(getInjuryData).then(function (res) {
      vm.playersInjuryInfo = [];

      vm.playerTotal = 0;
      vm.playerNormal = 0;
      vm.playerRecovery = 0;
      vm.playerCare = 0;
      vm.playerOperation = 0;

      var players = vm.appContext.players.all;
      var data = res.data.data;

      for (let i = 0; i < players.length; i++) {
        let user_id = +(players[i].user_id);
        let idx = _.findIndex(
          data,
          {
            'user_id': user_id
          }
        );

        // console.log(i, players[i].name, idx)

        if (idx == -1) {
          let injuryInfo = {
            user_id: players[i].user_id,
            user_name: players[i].name,
            state_id: -1,
            state_name: '-',
            date: '-',
            cause_id: -1,
            cause_name: '-',
            part_id: -1,
            part_name: '-',
            cat_id: -1,
            cat_name: '-',
            location_id: -1,
            location_name: '-',
            movement_id: -1,
            movement_name: '-'
          };
          vm.playersInjuryInfo.push(injuryInfo);
          vm.playerNormal++;
        } else {

          vm.playersInjuryInfo.push(data[idx]);

          // {id: 1, name: "정상"}, {id: 2, name: "치료중"}, {id: 3, name: "회복중"}, {id: 4, name: "수술"}
          if (data[idx].state_id === 1) {
            vm.playerNormal++;
          }
          if (data[idx].state_id === 2) {
            vm.playerCare++;
          }
          if (data[idx].state_id === 3) {
            vm.playerRecovery++;
          }
          if (data[idx].state_id === 4) {
            vm.playerOperation++;
          }

        }

        vm.playerTotal++;

        vm.metaData.user = vm.playersInjuryInfo[0];
      }
    }).catch(function (e) {
      console.log('ERROR', e);
    });
  }
  dataList();

  vm.getPlayerInjuryInfo = dataList;

  var list = function () {
    var data = {
      login_id: vm.appContext.user.login_id,
    };
    DashboardService.list(data)
      .then(function (res) {
        vm.contents = res.data.lists[3].list[0].contents;
        vm.videos = res.data.lists[3].list[0].videos;
        _.forEach(vm.videos, video => {
          if (video.url.indexOf('?v=') > -1) {
            video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
          } else {
            video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
          }
        });


      })
      .catch(function (error) {
        console.log('ERROR : ', error);
      });
  }
  list();

  vm.set = function (type, is_video) {

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      type: type,
      is_video: is_video,
      is_admin: 'N',
      title: is_video === 'Y' ? vm.video.title : vm.content.title,
      subtitle: is_video === 'Y' ? vm.video.subtitle : vm.content.subtitle,
      url: is_video === 'Y' ? vm.video.url : vm.content.url
    };

    if (!data.title) {
      toastr.error('제목을 입력하세요');
      return;
    }

    if (!data.subtitle) {
      toastr.error('구분을 선택하세요');
      return;
    }

    if (!data.url) {
      toastr.error('url을 입력하세요');
      return;
    }


    DashboardService.set(data).then(function (res) {
      list();
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  }

  vm.recommendedVideos = [];

  vm.isFirstSearch = true;
  var footballArr = ['football', 'football', 'football', 'soccer', 'soccer', 'futsal']; // 검색결과가 다양하게 나오게 하기 위한 처리, football, soccer 에 가중치를 줌
  
  // 영상 구분을 선택하면 영상 추천
  $scope.$watch('vm.video.subtitle', function (newVal, oldVal) {
    var container = $('#injury-recommend-results');

    if (!newVal) {
      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">영상 등록에서 구분을 선택해주십시오</li>');
    } else {
      var keyword = newVal;

      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
      var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' injury ' + newVal;
      var params = {
        q: q,
        part: 'snippet', 
        maxResults: 5,
        pageToken: 'CAoQAA' // 조회할 때마다 다른 결과가 조회되게 하기 위해 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      };

      PlanService.getVideoRecommend(params)
        .then(function(res) {
          container.empty();
          var srchItems = res.items,
            videos = [];
          $.each(srchItems, function(index, item) {
            if  (item.id.kind === 'youtube#video') {
              videos.push({
                id: item.id.videoId,
                title: item.snippet.title,
                url: 'https://youtube.com/watch?v='  +  item.id.videoId
              });

              var vidThumburl =  item.snippet.thumbnails.default.url;                 
              var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
              var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a><a href="#" class="select-video" style="margin-left:20px; text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

              container.append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
            }
          });

          vm.recommendedVideos = videos;

          vm.isFirstSearch = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  });

  // 추천영상 보기
  $('body').off('click.selectVideo').on('click.playVideo', '.play-video', function(e) {
    e.preventDefault();

    var anchor = $(this);
    document.getElementById('recommended_video').style.display = 'block';

    $scope.$apply(function () {
      vm.recommendedVideo = _.find(vm.recommendedVideos, {
        id: anchor.data('id')
      });
    });
  });

  // 추천영상 선택
  $('body').off('click.selectVideo').on('click.selectVideo', '.select-video', function(e) {
    e.preventDefault();

    var anchor = $(this);

    $scope.$apply(function () {
      vm.video.url = anchor.data('url');
      vm.video.title = anchor.data('title');
    });

    toastr.success('영상이 선택되었습니다.');
  });

  vm.remove = function (id) {
    // var data = {
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   id: id
    // };
    // DashboardService.remove(data).then(function (res) {
    //   list();
    // });


    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id
            };
            DashboardService.remove(data).then(function (res) {
              list();
            }).catch(function (e) {
              console.log('ERROR ' + e);
            });


          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
          // action: function (scope, button) {
          // }
        },
      }
    });

  }

  vm.go = function (url) {
    window.open(url, '_blank');
  }


  vm.metaData = {};
  var getInjuryMeta = function () {
    var getInjuryData = {};
    getInjuryData.login_id = vm.appContext.user.login_id;
    getInjuryData.uuid = vm.appContext.user.uuid;
    AnalysisService.getInjury(getInjuryData).then(function (res) {
      var data = res.data;
      
      vm.metaData.states = data.states;
      vm.metaData.state = vm.metaData.states[0];

      vm.metaData.causes = data.causes;
      vm.metaData.cause = vm.metaData.causes[0];

      vm.metaData.parts = data.parts;
      vm.metaData.part = vm.metaData.parts[0];

      vm.metaData.cats = data.cats;
      vm.metaData.cat = vm.metaData.cats[0];

      vm.metaData.locations = data.locations;
      vm.metaData.location = vm.metaData.locations[0];

      vm.metaData.movements = data.movements;
      vm.metaData.movement = vm.metaData.movements[0];
    }).catch(function (e) {
      console.log('ERROR', e);
    });
  }
  getInjuryMeta();

  $scope.$on('youtube.player.ready', function ($event, player) {
    $rootScope.YTPlayer = player;
  });


  // 역량검색, 부상검색, 훈련검색, 경기검색
  vm.contentSearch = function() {
    var container = $('#health-recommend-results');

    if (!newVal) {
      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">영상 등록에서 구분을 선택해주십시오</li>');
    } else {
      var keyword = newVal;
      if (keyword === '소모' || keyword === '섭취') {
        keyword = '칼로리 ' + keyword;
      }

      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
      var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' health ' + newVal;
      var params = {
        q: q,
        part: 'snippet', 
        maxResults: 5,
        pageToken: 'CAoQAA' // 조회할 때마다 다른 결과가 조회되게 하기 위해 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      };
      
      PlanService.getVideoRecommend(params)
        .then(function(res) {
          container.empty();
          var srchItems = res.items,
            videos = [];
          $.each(srchItems, function(index, item) {
            if  (item.id.kind === 'youtube#video') {
              videos.push({
                id: item.id.videoId,
                title: item.snippet.title,
                url: 'https://youtube.com/watch?v='  +  item.id.videoId
              });

              var vidThumburl =  item.snippet.thumbnails.default.url;                 
              var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
              var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a><a href="#" class="select-video" style="margin-left:20px; text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

              container.append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
            }
          });

          vm.recommendedVideos = videos;

          vm.isFirstSearch = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  };


  // 공공데이터 API 연계 검색
  // 부상, 회복에 회복약, 회복의약품, 회복식품, 회복의류기기 검색 => 표출
  // 칼로리 검색 - 식품안전나라, 식품영양성분 DB API
  vm.publicDataSearch = function() {
    var container = $('#health-recommend-results');

    if (!newVal) {
      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">영상 등록에서 구분을 선택해주십시오</li>');
    } else {
      var keyword = newVal;
      if (keyword === '소모' || keyword === '섭취') {
        keyword = '칼로리 ' + keyword;
      }

      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
      var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' health ' + newVal;
      var params = {
        q: q,
        part: 'snippet', 
        maxResults: 5,
        pageToken: 'CAoQAA' // 조회할 때마다 다른 결과가 조회되게 하기 위해 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      };
      
      PlanService.getVideoRecommend(params)
        .then(function(res) {
          container.empty();
          var srchItems = res.items,
            videos = [];
          $.each(srchItems, function(index, item) {
            if  (item.id.kind === 'youtube#video') {
              videos.push({
                id: item.id.videoId,
                title: item.snippet.title,
                url: 'https://youtube.com/watch?v='  +  item.id.videoId
              });

              var vidThumburl =  item.snippet.thumbnails.default.url;                 
              var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
              var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a><a href="#" class="select-video" style="margin-left:20px; text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

              container.append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
            }
          });

          vm.recommendedVideos = videos;

          vm.isFirstSearch = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  };


}

export default {
  name: 'InjuryCtrl',
  fn: InjuryCtrl
};
